import { fetchCatalogItemsByCategoryId } from '@/redux/actions';
import store from '@/redux/store';
import { DEFAULT_GET_ITEMS_API_PAGE_SIZE } from '../../MiddleBody7/utils';

export const getProducts = (
  id,
  type,
  pageNo = 0,
  storeId,
  sortType,
  storePrevitem = true, // Used to reset product list in case of numbered pagination. For infinite scroll we append to previously fetched data hence the value will be true by default representing infinite scroll.
  itemsPerPage = DEFAULT_GET_ITEMS_API_PAGE_SIZE
) => {
  const staleStoreId = store.getState().storeReducer.store.store_id;
  const dispatch = store.dispatch;
  const sID = storeId || staleStoreId;

  if (!sID) return;
  return new Promise((resolve, reject) => {
    dispatch(
      fetchCatalogItemsByCategoryId(
        {
          store_id: sID,
          category_id: id,
          category_type: type,
          page_no: pageNo,
          sort_type: sortType,
          items_per_page: itemsPerPage,
          storePrevitem,
        },
        (status, isNextPage) =>
          status ? resolve({ status, isNextPage }) : reject(status)
      )
    );
  });
};
